export const PatientCreateSteps = {
  PATIENT_INTRO: 'patient-intro',
  PATIENT_ALREADY_EXISTS: 'patient-already-exists',
  PATIENT_EMAIL_ACCOUNT_WAS_FOUND: 'patient-account-was-found',
  PATIENT_PHONE_ACCOUNT_WAS_FOUND: 'patient-phone-account-was-found',
  PATIENT_MULTIPLE_ACCOUNTS_FOUND: 'patient-multiple-accounts-found',
  PATIENT_INFORMATION: 'patient-information',
  PATIENT_SETTINGS: 'patient-settings',
} as const;

export const PatientInformationInviteLabels = {
  text: 'Text Message',
  email: 'Email',
} as const;
